export default "__VITE_ASSET__l_JrjQ4x__"